/*eslint eqeqeq:0 */
define('glu/templateHelpers',['require','./date','./number','./locale','./currencies','./util','handlebars','hbs!./template/iconTemplate.hbs','./routeManager'],function(require) {
    'use strict';

    var date = require('./date'),
        number = require('./number'),
        locale = require('./locale'),
        currencies = require('./currencies'),
        util = require('./util'),
        Handlebars = require('handlebars'),
        iconTemplate = require('hbs!./template/iconTemplate.hbs'),
        routeManager = require('./routeManager');

    /**
     * Format a numeric value.  A default format will be used if a format value is not provided.
     *
     * @param value
     * @param format
     * @returns {*}
     */
    function numberHelper(value, format) {
        try {
            return util.isString(format) ?
                number(value).format(format) :
                number(value).format('0,0');
        } catch (e) {
            return value;
        }
    }

    /**
     * Unformat a formated number value
     * @param value
     * @returns {*}
     */
    function unformatNumber(value) {

        return number().unformat(value);
    }

    /**
     * Format a date value.  A default format will be used if a format value is not provided.
     *
     * @param value
     * @param format
     * @returns {*}
     */
    function dateHelper(value, format) {
        try {
            return util.isString(format) ?
                date(value).format(format) :
                date(value).format(templateHelpers.defaultDateFormat);
        } catch (e) {
            return value;
        }
    }

    /**
     * Format a float value.  A default format will be used if a format value is not provided.
     *
     * @param value
     * @param format
     * @returns {*}
     */
    function amountHelper(value, format) {
        try {
            return util.isString(format) ?
                numberHelper(value, format) :
                numberHelper(value, '0,0.00');
        } catch (e) {
            return value;
        }
    }

    /**
     * NOTE: Optional arguments seem to be set to a function of some sort.  We must test
     * the datatype of the optional argument, otherwise an error is thrown and the page will fail to render.
     */
    var templateHelpers = {
        // Added this so that it's easy to globally override the default date format
        defaultDateFormat: 'DD MMM YYYY',

        /**
         * Retrieve the specified key from glu locale.  Return the defaultString if not found.
         *
         * @param key
         * @param defaultString
         * @returns {*}
         */
        locale: function(key, defaultString) {
            return util.isString(defaultString) ?
                locale.getDefault(key, defaultString) :
                locale.get(key);
        },

        /**
         * Returns WCAG-compliant icon markup.
         */
        icon: function(name, text, context) {

            if (util.isObject(name)) {
                context = name;
            } else if (util.isObject(text)) {
                context = text;
                context.hash.name = name;
            } else {
                context.hash.name = name;
                context.hash.text = text;
            }

            if (context.hash.locale) {
                context.hash.text = locale.get(context.hash.locale);
            }

            var options = util.extend({
                text: '',
                name: 'question-solid'
            }, context.hash);
            options.title = options.title || options.text;
            options.primaryTagName = options.action ? 'button' : 'div';
            return new Handlebars.SafeString(iconTemplate(options));
        },

        date: dateHelper,

        number: numberHelper,

        removeNumberFormat: unformatNumber,

        time: function(value) {
            return dateHelper(value, 'LT');
        },

        time24: function(value) {
            return dateHelper(value, 'HH:mm');
        },

        amount: amountHelper,

        /**
         * Format a currency value.  Same as `amount`, but without a thousand separator. A format value may also be provided.
         *
         * @param value
         * @param format
         * @returns {*}
         */
        money: function(value, format) {
            return util.isString(format) ?
                amountHelper(value, format) :
                amountHelper(value, '0.00');
        },

        abbrNumber: function(value) {
            value = +value || 0;

            if (value > 999) {
                return numberHelper(value, '0.0a');
            }

            // Always return value as string
            return '' + value;
        },

        isEqual: function(value, test, options) {
            if (value == test) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        },

        isStrictlyEqual: function(value, test, options) {
            if (value === test) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        },

        pluralize: function(quantity, singular, plural) {
            var digit = numberHelper(quantity),
                singularString = singular ? locale.get(singular, digit) : digit,
                pluralString = plural ? locale.get(plural, digit) : digit;

            return quantity === 1 ? singularString : pluralString;
        },

        currencyName: function(isoCode) {
            var match = currencies.get(isoCode);
            return match ? match.name : '??' + isoCode + '??';
        },

        currencySymbol: function(isoCode) {
            var match = currencies.get(isoCode);
            return match ? match.symbol : '??' + isoCode + '??';
        },

        route: function(route, options) {
            options = (options && options.hash) ? options.hash : options;

            var routeToUse = routeManager[route] || route;

            if (options && util.isFunction(routeToUse.params)) {
                return routeManager.root + routeToUse.params(options);
            }

            return routeManager.root + routeToUse;
        }
    };

    // Register all helpers with Handlebars
    util.each(templateHelpers, function(fn, name) {
        Handlebars.registerHelper(name, fn);
    });

    return templateHelpers;
});

